import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  title: 'Something went wrong',
  description:
    'We are unable to fetch results right now. Please try again in a few moments.',
})
